import {Component, inject, OnInit, output, signal, ChangeDetectionStrategy} from "@angular/core"
import {FormsModule} from "@angular/forms"
import {MatButtonToggleModule} from "@angular/material/button-toggle"
import {MatTooltipModule} from "@angular/material/tooltip"
import {IsDefined} from "@cm/utils/filter"
import {fetchThrowingErrors} from "@common/helpers/api/fetch"
import {NextActor} from "@generated"
import {NextActorLabels} from "@labels"
import {AssignUserDialogVisibleUsersGQL} from "@platform/components/users/assign-user-dialog/assign-user-dialog.generated"
import {AssignUserComponent, AssignUserData} from "@platform/components/users/assign-user/assign-user.component"
import {UserThumbnailComponent} from "@platform/components/users/user-thumbnail/user-thumbnail.component"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-assign-user-dialog",
    templateUrl: "./assign-user-dialog.component.html",
    styleUrls: ["./assign-user-dialog.component.scss"],
    imports: [MatTooltipModule, MatButtonToggleModule, FormsModule, UserThumbnailComponent],
})
export class AssignUserDialogComponent extends AssignUserComponent implements OnInit {
    readonly $userChange = output<{id: string} | undefined>({alias: "userChange"})
    readonly $nextActorChange = output<NextActor>({alias: "nextActorChange"})

    readonly NextActor = NextActor
    readonly visibleUsersGql = inject(AssignUserDialogVisibleUsersGQL)

    readonly $visibleUsers = signal<AssignUserData[] | null>(null)

    readonly $editableNextActor = signal<NextActor | undefined>(undefined)

    updateNextActor(nextActor: NextActor) {
        this.$editableNextActor.set(nextActor)
        this.$nextActorChange.emit(nextActor)
        this.update()
    }

    override update() {
        super.update()
        const nextActor = this.$editableNextActor() ?? this.$nextActor()
        this.$nextActorLabel.set(nextActor ? NextActorLabels.get(nextActor) : undefined)
    }

    async assignUser(user: AssignUserData) {
        this.$userChange.emit(user)
        this.update()
    }

    async deleteAssignedUser() {
        this.$userChange.emit(undefined)
        this.update()
    }

    ngOnInit() {
        fetchThrowingErrors(this.visibleUsersGql)({}).then(({users}) => {
            this.$visibleUsers.set(users.filter(IsDefined))
        })
    }
}
